<!-- Added form to disable autocomplete-->
<form autocomplete="off">
  <!-- z-0 class is used to hide the real hornavbar, since it is the central app component, which loads all initial data.-->
  <!-- Instead of the real hornavbar we use the fake one in the entrance component -->
  <div class="nav-container" [class.z-0]="currentPage === EntranceUrl" [class.box-shadow-bttm]="hasScrolledDown">
    <div class="aligned-row-container  {{ currentPageHeader ? 'leftSide' : '' }}">
      <app-button
        *ngIf="currentPageHeader === 'Account settings' || currentPageHeader === 'Organization & users'"
        data-qa="hov-nav-bar-back-button"
        [size]="'small'"
        [type]="'grey-accent'"
        [iconName]="'back.svg'"
        queryParamsHandling="preserve"
        (buttonClick)="goBack()">Back
      </app-button>
      <span id="header">{{ currentPageHeader }}</span>
      <div *ngIf="currentPageHeader" class="xAxis-whitespace-0p75"></div>
        <app-button
          *ngIf="isDisableOrgSelectorAndShowButtonBack"
          [type]="'grey-accent'"
          [size]="'small'"
          [iconName]="'back.svg'"
          (buttonClick)="clickOnBack()">
          Back
        </app-button>
      <div
        *ngIf="showElements.singleOrg"
        data-qa="org-picker-single-org"
        [formGroup]="selectedSingleOrgForm"
        [class.not-clickable]="isDisableOrgSelectorAndShowButtonBack"
        class="picker centered-column-container"
        (mouseenter)="activateOrgPicker()"
        (mouseleave)="deactivateOrgPicker()">
        <span class="picker-header">Organization</span>
        <div class="picker-name">
          <span>{{selectedOrganization ? selectedOrganization.name : "Organization" }}</span>
          <div class="xAxis-whitespace-xtiny"></div>
            <app-all-icons
              *ngIf="!isDisableOrgSelectorAndShowButtonBack"
              [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'">
            </app-all-icons>
        </div>
        <div
          *ngIf="showPicker.org.isShown"
          @fadeInOut
          data-qa="organization-selector"
          class="picker-dropdown centered-column-container">
          <div class="autocomplete-input centered-row-container">
            <app-input
              data-qa="hor-nav-organization-selector"
              formControlName="selectedSingleOrg"
              [placeholder]="'Search Organization...'"
              [suffixFirstIcon]="'close.svg'"
              (suffixFirstIconEmitter)="resetOrgInputValue()">
            </app-input>
          </div>
          <div class="centered-column-container picker-list">
            <ng-container *ngFor="let org of filteredOrganizations | async">
                <div class="centered-column-container list-block">
                  <app-text-with-tooltip
                    [attr.data-qa]="'list-entry-' + org.name"
                    class="list-entry display-unset content-center {{ org === selectedOrganization ? 'selected' : '' }}"
                    [text]="org.name"
                    [positionType]="'left'"
                    (click)="setSelectedOrgFromOrganizationPage(org)"
                  />
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <app-org-picker *ngIf="showElements.showOrgFundPicker"
          data-qa="org-picker"
          #orgPicker
          [organizationsWithServiceAccess]="organizationsWithServiceAccess"
          [currentService]="currentService"
          (entitySelectionEmitter)="changeSelectedEntity($event)">
        </app-org-picker>
        <app-period-picker *ngIf="showElements.periods"
          data-qa="period-picker"
          #periodPicker
          [showElements]="showElements"
          [selectedOrganization]="selectedOrganization"
          [isMultiAccess]="isMultiAccess"
          [selectedFundPerformance]="selectedFundPerformance"
          [filteredFundPerformances]="filteredFundPerformances"
          [currentService]="currentService"
          [fsNavData]="fsNavData"
          [isManagementEntity]="is.selectedManagementEntity"
          (fundPerformanceChange)="switchFp($event)"
          (actionEmitter)="pickerActionCatcher($event)">
        </app-period-picker>
      <div class="aligned-row-container " *ngIf="showElements.market_analysis ">
        <app-ma-selector
          data-qa="ma-period-selector"
          [title]="'Reporting period'"
          [selectedPeriod]="marketAnalysis.reported.selected"
          [periods]="marketAnalysis.reported.periods"
          [selectorType]="MaSelector.REPORTED_PERIODS"
          (selectPeriod)="selectMarketAnalysisPeriod($event.period, $event.selectorType)">
        </app-ma-selector>
        <app-ma-selector *ngIf="showElements.vintagePeriods"
          data-qa="-ma-vintage-from"
          [title]="'Vintage from'"
          [selectedPeriod]="marketAnalysis.vintage.from.selected"
          [periods]="marketAnalysis.vintage.from.periods"
          [selectorType]="MaSelector.FROM"
          (selectPeriod)="selectMarketAnalysisPeriod($event.period, $event.selectorType)">
        </app-ma-selector>
        <app-ma-selector *ngIf="showElements.vintagePeriods"
          data-qa="-ma-vintage-till"
          [title]="'Vintage till'"
          [selectedPeriod]="marketAnalysis.vintage.till.selected"
          [periods]="marketAnalysis.vintage.till.periods"
          [selectorType]="MaSelector.TILL"
          (selectPeriod)="selectMarketAnalysisPeriod($event.period, $event.selectorType)">
        </app-ma-selector>
      </div>
      <!--Extra functionality for other components-->
      <app-numberswitcher
        *ngIf="showElements.numberSwitcher"
        data-qa="number-switcher"
        [switcher]="boxType.NUMBER"
        (numberSwitcher)="setNumberSwitcher($event)">
      </app-numberswitcher>
      <app-numberswitcher
        *ngIf="showElements.periodTypeSwitcher"
        data-qa="period-type-switcher"
        [switcher]="boxType.DATE"
        (dateSwitcher)="setDateSwitcher($event)">
      </app-numberswitcher>
      <app-button
        *ngIf="showElements.allPeriodsButton"
        data-qa="all-periods-button"
        [class.pd-l-1]="!showElements.numberSwitcher"
        [type]="'grey-accent'"
        [size]="'small'"
        [iconName]="'calendar.svg'"
        (buttonClick)="goToAllPeriods()">
        All periods
      </app-button>
    </div>

    <div class="aligned-row-container rightSide">
      <ng-container *ngIf="showUI && showElements.logoSlider">
        <div
          class="circle centered-row-container"
          title="Replace UI with Organization Logo"
          (click)="showUI = !showUI">
          <svg
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 12L10 8L6 4"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div *ngIf="isMultiAccess && showElements.adminSwitcher">
          <app-switcher
            data-qa="viewer-admin-switcher"
            id="accessSwitcher"
            [checked]="userType === 'admin'"
            [leftText]="'Viewer'"
            [rightText]="'Admin'"
            [noPropagation]="is.switcherDisabled"
            (mouseenter)="activateTooltip('accessSwitcher')"
            (mouseleave)="hideTooltip()"
            (checkedChanged)="changeViewerAdminView()">
          </app-switcher>
        </div>
        <div class="position-rel">
          <app-hornavbar-company-search
            *ngIf="showElements.search"
            id="searchID"
            (selectedCompanyEmitter)="changeFundAndPeriodByCompany($event)">
          </app-hornavbar-company-search>
        </div>

        <app-all-icons *ngIf="isMultiAccess && showElements.notifications"
          data-qa="reminders-button"
          class="clickable"
          [iconNameAndStyling]="(is.isActiveRemindersLoaded ? 'reminders-active.svg;' : 'reminders.svg;')
            +  ' icon-size-2 black-10'"
          (click)="is.showRemindersModal = true">
        </app-all-icons>

        <!-- actual ai button in hornavbar -->
        <app-ai-button
          *ngIf="showElements.orcaAiButton"
          data-qa="hornavbar-orca-ai-button"
          class="hornavbar-orca-ai-button"
          (buttonClick)="openAiModal()">
          <div class="flex items-center gap-0.3125">
            <div>AI</div>
            <div class="relative">
              <div class="beta">BETA</div>
            </div>
          </div>
        </app-ai-button>
        <app-nav-avatar [orgAccesses]="orgAccesses" [showUserManagementOptions]="showUserManagementOptions"/>
      </ng-container>
      <div *ngIf="!showUI" (click)="showUI = !showUI" class="backArrow">
        <div
          class="circle-back centered-row-container"
          (click)="showUI = !showUI">
          <svg
            width="1.5em"
            height="1.5em"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 12L6 8L10 4"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <img
          [src]="selectedOrganization.logo"
          alt="organization logo"
          #logo
          class="orgLogo"
          (error)="logo.src = errorImageLink"
        />
      </div>
    </div>
  </div>
</form>

<app-modal-copy-period
  *ngIf="is.copyPeriodModalOpen"
  [selectedFundUuid]="selectedOrganization.selectedFund?.uuid"
  [selectedPeriod]="selectedPeriod"
  [periods]="periods"
  (emitter)="copyPeriodEmitted($event)"
/>

<app-modal-delete-period
  *ngIf="is.deletePeriodModalOpen"
  [selectedFundUuid]="selectedOrganization.selectedFund?.uuid"
  [selectedPeriod]="selectedPeriod"
  (emitter)="deletePeriodEmitted($event)"
/>

<app-tooltip
  *ngIf="toolTipSettings?.show"
  [yShift]="is.tooltipForSwitcher ? '-4.7em' : '0em'"
  [coordinates]="toolTipSettings.coordinates"
  [title]="toolTipSettings.title"
/>

<app-reminders
  *ngIf="is.showRemindersModal"
  [selectedOrganization]="selectedOrganization"
  [organizationsWithRole]="organizationsWithRoles"
  (hasActiveRemindersEmitter)="is.isActiveRemindersLoaded = $event"
  (closeEmitter)="is.showRemindersModal = false"
/>

<app-modal-fund-performance-update
  *ngIf="is.showFpUpdateModal"
  [selected]="{
    org: selectedOrganization,
    period: selectedPeriod,
    periods: periods,
    fp: selectedFundPerformance,
  }"
  [fundPerformanceList]="fundPerformances"
  [isFromCopyPeriodModal]="true"
  (fundPerfSetter)="updateFpFromModal($event)"
  (isConfirmedUpdate)="closeFpUpdateModal($event)"
  (deleteFundPerformance)="is.showDeleteFpModal = true"
/>

<app-modal-dialog
  *ngIf="is.showDeleteFpModal"
  [header]="'Delete period'"
  [useStandardList]="false"
  (isConfirmed)="deleteFundPerformance($event)"/>

<!--
 the button is in the bottom-right corner an is partially shown, on hover it slides to the left and is shown in full hd.
 its not actually rendered in hornavbar, but it acts same as the one inside of it, therefore i put it inside this component
-->
<app-ai-button
  *ngIf="showElements.orcaAiButton"
  data-qa="bottom-right-orca-ai-button"
  class="hornavbar-orca-ai-button-bottom-right"
  (buttonClick)="openAiModal()">
  <div class="flex items-center gap-0.3125">
    <span>AI</span>
    <div class="relative">
      <div class="beta">BETA</div>
    </div>
  </div>
</app-ai-button>

<app-global-ai-chat-modal
  *ngIf="showGlobalAiModal"
  (closeEmitter)="showGlobalAiModal=false"
/>
